export function isPreview() {
  return document.documentElement.hasAttribute('data-turbolinks-preview')
}
